(function(){
  'use strict';
  var root=document.querySelector('[data-nnf-hub]');
  if(!root)return;
  function capture(name,detail){
    var privacy=window.Shopify&&window.Shopify.customerPrivacy;
    try{
      if(!privacy||typeof privacy.analyticsProcessingAllowed!=='function'||!privacy.analyticsProcessingAllowed())return;
      if(window.NNPostHog&&typeof window.NNPostHog.capture==='function')window.NNPostHog.capture(name,detail);
    }catch(error){}
  }
  var form=root.querySelector('[data-nnf-search]');
  if(form)form.addEventListener('submit',function(){var input=form.querySelector('[name="q"]');capture('field_notes_search',{query_length:input.value.trim().length});});
  root.addEventListener('click',function(event){
    var link=event.target.closest('a');
    if(!link)return;
    if(link.hasAttribute('data-nnf-topic'))capture('field_notes_topic',{topic:link.getAttribute('data-nnf-topic')});
    if(link.hasAttribute('data-nnf-note'))capture('field_notes_article_open',{article_path:new URL(link.href,location.origin).pathname});
    if(link.hasAttribute('data-nnf-standard'))capture('field_notes_standard_open',{});
  });
  if(root.getAttribute('data-nnf-performed')==='true')capture('field_notes_search_results',{result_count:Number(root.getAttribute('data-nnf-results'))||0});
})();
